<script>
  import { getContext } from 'svelte'
  import ImageGallery from '../ImageGallery'
  import ModalBackLink from '../ModalBackLink'
  import ImageThumbnail from './ImageThumbnail.svelte'

  export let images = []
  export let focusable = true
  export let galleryLink = false

  const { open: openPhotoswipe } = getContext('photoswipe')
  const { open: openModal } = getContext('simple-modal')
  const maxPreviews = 4

  $: hiddenImages = Math.max(0, images.length - maxPreviews)

  function overlayContentForImage (imageIndex) {
    if (galleryLink && hiddenImages > 0 && imageIndex === maxPreviews - 1) {
      return `+${hiddenImages}`
    }
  }

  function openGalleryModal() {
    openModal(
      ImageGallery,
      { images },
      {
        styleWindowWrap: { width: '100%', height: '100%', margin: 0 },
        styleWindow: { width: '100%', height: '100%', margin: 0, overflowY: 'auto', borderRadius: 0 },
        styleContent: { paddingTop: 0, maxHeight: 'initial' },
        closeButton: ModalBackLink
      }
    )
  }

  function onThumbnailClick (image) {
    if (galleryLink && hiddenImages > 0 && images.indexOf(image) === maxPreviews - 1) {
      openGalleryModal()
    } else if (focusable) {
      openPhotoswipe(images, image)
    }
  }

  const thumbClickable = (index) => focusable || (galleryLink && index === maxPreviews - 1)
</script>

<div class='thumbs-gallery'>
    {#each images.slice(0, maxPreviews) as image, index }
        <div class='thumb'>
            <ImageThumbnail
                image={image}
                overlay={overlayContentForImage(index)}
                clickable={thumbClickable(index)}
                on:click={() => onThumbnailClick(image)}
            />
        </div>
    {/each}
</div>

<style>
    .thumbs-gallery {
        --width-per-item: 25%;

        position: relative;
        height: 100%;
        width: 100%;

        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .thumb {
        position: relative;
        width: var(--width-per-item);
        height: 100%;
    }

    .thumb:not(:last-child) {
        margin-right: var(--spacer-sm);
    }
</style>
